import { Box, Typography } from "@mui/material";
import MainModal from "components/MainModal";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import { IDeleteItemModal } from "../RCAFishboneDiagramInterfaces";
import { useTranslation } from "react-i18next";

const DeleteItemModal = ({ open, onClose, itemToDelete, onDeleteItem, disabled }: IDeleteItemModal) => {
    const mainClasses = useRCAMainStyles();
    const { t } = useTranslation();

    const handleOnClose = () => {
        onClose();
    };

    return (
        <MainModal
            isOpen={open}
            onClose={handleOnClose}
            title={t("rca.rca_library.rca_detail.fishbone_diagram.delete_item_title")}
            showCloseButton
            customModalStyles={{ width: 600 }}
            onOkButtonClick={() => {
                onDeleteItem(itemToDelete!);
                handleOnClose();
            }}
            okButton={t("rca.rca_library.rca_detail.fishbone_diagram.delete_item_confirm")}
            okButtonColor="error"
            disableOkButton={disabled}
        >
            <Box className={`${mainClasses.contentCardContent}`}>
                <Typography variant="body1">
                    {t("rca.rca_library.rca_detail.fishbone_diagram.delete_item_warning")}
                </Typography>
            </Box>
        </MainModal>
    );
};

export default DeleteItemModal;
